import { createAction } from '@reduxjs/toolkit'
import { CurrentType, DataMint, HistoryType } from './types'

export const fetchActionActiveTab = createAction<{ activeTab: number }>('fetchActionActiveTab')
export const fetchCurrent = createAction<{ dataCurrent: CurrentType }>('fetchCurrent')
export const fetchTxHash = createAction<{ txHash: string }>('fetchTxHash')
export const fetchDataMint = createAction<{ dataMint: DataMint }>('fetchDataMint')
export const fetchDataHistory = createAction<{ dataHistory: HistoryType }>('fetchDataHistory')
export const resetDataHome = createAction('resetDataHome')
export const fetchTabChart = createAction<{ tabChart: string }>('fetchTabChart')
export const fetchLoadingDataMint = createAction<{ loading: boolean }>('fetchLoadingDataMint')
export const fetchDataInfoAddress = createAction<{ data: any }>('fetchDataInfoAddress')
